import { createAction, createSlice } from "@reduxjs/toolkit";

export const globalSlice = createSlice({
  name: "global",
  initialState: {
    mainHeaderVisibility: false,
    subHeaderTitle: "",
    navBarVisibility: false,
    device: {},
  },
  reducers: {
    setMainHeaderVisibility: (state, action) => {
      state.mainHeaderVisibility = !!action.payload;
    },
    setSubHeaderTitle: (state, action) => {
      state.subHeaderTitle = action.payload;
    },
    setNavBarVisibility: (state, action) => {
      state.navBarVisibility = !!action.payload;
    },
    setDevice: (state, action) => {
      state.device = action.payload;
    },
  },
});

export const setMainHeaderVisibilityAction = createAction("global/setMainHeaderVisibility");
export const setSubHeaderTitleAction = createAction("global/setSubHeaderTitle");
export const setNavBarVisibilityAction = createAction("global/setNavBarVisibility");
export const setDeviceAction = createAction("global/setDevice");

export default globalSlice.reducer;